// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Bus from '../_raw/service/icon_bus.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Bus);
